<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-06-26 15:09:19
 * @LastEditTime: 2019-08-30 17:27:59
 * @LastEditors: Please set LastEditors
 -->
<template>
    <div class="content" v-loading="loading">
        <div class="pageTitle">追踪查询</div>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" style="margin: 20px;">
            <el-form-item label="">
                <el-input v-model="form.logistics_code" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            </el-form-item>
        </el-form>
        <div v-if="isTrue">
            <div class="blocknote">
            <span>
                基本信息
            </span>
            </div>
            <div class="page-table" v-if="baseData">
                <table width="100%" cellpadding="0" cellspacing="0" border="0">
                    <thead>
                    </thead>
                    <tbody id="content">
                    <tr>
                        <td>状态</td>
                        <td>
                            <span v-if="baseData.status == 0">未入库 <span v-if='baseData.is_devanning==1'>({{baseData.is_devanning==1?'拆箱':''}}{{baseData.inwarehouse_status==1?'未入库':''}})</span></span>
                            <span v-if="baseData.status == 1">已入库<span v-if='baseData.is_devanning==1'>({{baseData.is_devanning==1?'拆箱':''}}{{baseData.inwarehouse_status==1?'未入库':''}})</span></span>
                            <span v-if="baseData.status == 2">已发货<span v-if='baseData.is_devanning==1'>({{baseData.is_devanning==1?'拆箱':''}}{{baseData.inwarehouse_status==1?'未入库':''}})</span></span>
                            <span v-if="baseData.status == 3">已出货<span v-if='baseData.is_devanning==1'>({{baseData.is_devanning==1?'拆箱':''}}{{baseData.inwarehouse_status==1?'未入库':''}})</span></span>
                            <span v-if="baseData.status == 4">已调拨<span v-if='baseData.is_devanning==1'>({{baseData.is_devanning==1?'拆箱':''}}{{baseData.inwarehouse_status==1?'未入库':''}})</span></span>
                            <span v-if="baseData.status == 5">已零售<span v-if='baseData.is_devanning==1'>({{baseData.is_devanning==1?'拆箱':''}}{{baseData.inwarehouse_status==1?'未入库':''}})</span></span>
                            <span v-if="baseData.status == 6">已退货<span v-if='baseData.is_verify_status!=0'>({{baseData.is_verify_status==2?'审核失败':'未审核 '}})</span></span>

                            <span v-if="baseData.status == 7">已零售退货<span v-if='baseData.is_verify_status!=0'>({{baseData.is_verify_status==2?'审核失败':'未审核 '}})</span></span>


                        </td>
                    </tr>
                    <tr>
                        <td>标签类型</td>
                        <td>{{baseData.code_name}}   </td>
                    </tr>
                    <tr>
                        <td>批号</td>
                        <td>{{baseData.production_batch}}</td>
                    </tr>
                    <tr>
                        <td>包装类型</td>
                        <td>{{baseData.packaging_type}}</td>
                    </tr>
                    <tr>
                        <td>产品代码</td>
                        <td>{{baseData.product_sn}}</td>
                    </tr>
                    <tr>
                        <td>产品名称</td>
                        <td>{{baseData.product_name}}</td>
                    </tr>
                    <tr>
                        <td>产品规格</td>
                        <td>{{baseData.product_specs}}</td>
                    </tr>
                    <tr>
                        <td>产品数量</td>
                        <td>{{baseData.code_total}}</td>
                    </tr>
                    <tr>
                        <td>生产日期</td>
                        <td>{{baseData.production_date}}</td>
                    </tr>
                    <tr>
                        <td>有效日期</td>
                        <td>{{baseData.expiring_date}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="page-table" >
                <table width="100%" cellpadding="0" cellspacing="0" border="0">
                    <thead>
                    <tr>
                        <th>{{big_code_name}}</th>
                        <th>{{middle_code_name}}</th>
                        <th>{{small_code_name}}</th>
                        <th>流水号</th>
                    </tr>

                    </thead>
                    <tbody>
                    <tr v-for="item in codeData">
                        <td :class="item.big_code == form.logistics_code ? 'active' : 'normalClass'">{{item.big_code}}</td>
                        <td :class="item.middle_code == form.logistics_code ? 'active' : 'normalClass'">{{item.middle_code}}</td>
                        <td :class="item.small_code == form.logistics_code ? 'active' : 'normalClass'">{{item.small_code}}</td>
                        <td>{{item.serialnum}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="blocknote">
            <span>
                物流信息
            </span>
            </div>
            <div class="page-table last-page" style="margin: 10px">
                <table width="100%" cellpadding="0" cellspacing="0" border="0" style="margin: 15px" v-if="deliverData.length" v-for="item in deliverData">
                    <tbody>
                    <tr>
                        <td>日期
                        </td>
                        <td>{{item.created_at}}</td>
                    </tr>
                    <tr>
                        <td>
                            <span v-if="item.status == 1">入库单号</span>
                            <span v-if="item.status == 2">调仓单号</span>
                            <span v-if="item.status == 3">出货单号</span>
                            <span v-if="item.status == 4">调拨单号</span>
                            <span v-if="item.status == 5">零售单号</span>
                            <span v-if="item.status == 6">退货单号</span>
                            <span v-if="item.status == 7">退货单号</span>
                        </td>
                        <td>
                            <span v-if="item.status == 1||item.status == 2">{{item.stock_in_sn}}</span>
                            <span v-if="item.status == 3||item.status == 4||item.status == 5">{{item.stock_out_sn}}</span>
                            <span v-if="item.status == 7 || item.status == 6">{{item.return_goods_sn}}</span>
                        </td>
                    </tr>
                    <tr v-if="item.status == 3 && item.order_line_no">
                        <td>
                            <span >在线订单单号</span>
                        </td>
                        <td>
                            <span>{{item.order_line_no}}</span>
                        </td>
                    </tr>
                    <tr v-if="item.status == 3">
                        <td>
                            <span >是否赠品</span>
                        </td>
                        <td>
                            <span  v-if="item.isgift == 1">赠品</span>
                            <span  v-if="item.isgift == 2">非赠品</span>
                        </td>
                    </tr>

                    <tr>
                        <td>

                            <span v-if="item.status == 1">入库仓库</span>
                            <span v-if="item.status == 2">调出仓库</span>

                            <span v-if="item.status == 3">出货仓库</span>
                            <span v-if="item.status == 4">调出经销商</span>
                            <span v-if="item.status == 5">出货客户</span>

                            <span v-if="item.status == 6">退货客户</span>
                            <span v-if="item.status == 7">退货客户</span>
                        </td>
                        <td>

                            <span v-if="item.status == 1">{{item.warehouse_name}}</span>
                            <span v-if="item.status == 2">{{item.from_warehouse_name}}</span>

                            <span v-if="item.status == 3">{{item.warehouse_name}}</span>
                            <span v-if="item.status == 4">{{item.from_name}} </span>
                            <span v-if="item.status == 5">{{item.from_name}}</span>

                            <span v-if="item.status == 6">{{item.from_name}}</span>
                            <span v-if="item.status == 7">{{item.from_name}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>
                           

                            
                            <span v-if="item.status == 1">入库产品</span>
                            <span v-if="item.status == 2">调入仓库</span>

                            <span v-if="item.status == 3">出库产品</span>
                            <span v-if="item.status == 4">调入经销商</span>
                            <span v-if="item.status == 5">出货产品</span>

                            <span v-if="item.status == 6">退货产品</span>
                            <span v-if="item.status == 7">退货产品</span>
                        </td>
                        <td>
                               <span v-if="item.status == 1">{{item.product_name}}</span>
                            <span v-if="item.status == 2">{{item.warehouse_name}}</span>

                            <span v-if="item.status == 3">{{item.product_name}}</span>
                            <span v-if="item.status == 4">{{item.to_name}}</span>
                            <span v-if="item.status == 5">{{item.product_name}}</span>

                            <span v-if="item.status == 6">{{item.product_name}}</span>
                            <span v-if="item.status == 7">{{item.product_name}}</span>


                        </td>
                    </tr>
                    <tr v-if='item.status == 2||item.status == 3||item.status == 4'>


                        <td>
                            <span v-if="item.status == 2">入库产品</span>

                            <span v-if="item.status == 3">出库客户</span>
                            <span v-if="item.status == 4">入库产品</span>

                        
                        </td>
                        <td>
                            <span v-if="item.status == 2">{{item.product_name}}</span>
                            <span v-if="item.status == 3">{{item.from_name}}</span>
                            <span v-if="item.status == 4">{{item.product_name}}</span>

                        </td>
                    </tr>
                    
                    <tr v-if="item.status == 3">
                        <td>
                            <span >收货客户</span>
                        </td>
                        <td>
                            <span >{{item.to_name}}</span>
                        </td>
                    </tr>
                    <tr>
                        <td>操作人</td>
                        <td>{{item.operator}}</td>
                    </tr>
                    </tbody>
                </table>
           
            </div>
        </div>
        </div>
    
</template>

<script>
    export default {
        name: "trace-manage",
        data() {
            return {
                form:{
                    logistics_code:''
                },
                isShow:false,
                baseData:{},
                codeData:[],
                deliverData:[],
                big_code_name:'',
                middle_code_name:'',
                small_code_name:'',
                isTrue:false,
                loading:false
            }
        },
        methods: {
            getConfigInfo(){
                this.$get('logistics', '/configs', {
                    lang: ''
                }).then(res => {
                    this.big_code_name = res.data.big_code_name;
                    this.middle_code_name = res.data.middle_code_name;
                    this.small_code_name = res.data.small_code_name;
                }).catch(function (error) {
                    console.log(error);
                });
            },

            onSearch(){
                this.loading = true;
                this.$get('logistics','/logistics.search', {
                    lang:'',
                    logistics_code:this.form.logistics_code
                }).then(res => {
                    this.loading = false;
                    this.isTrue = true;
                    console.log(res.data.base_info);
                    this.isShow = true;
                    this.baseData = res.data.base_info;
                    this.codeData = res.data.code_list;
                    this.deliverData = res.data.logistics_info;
                }).catch(error => {
                    this.loading = false;
                    this.$message({
                        type: 'error',
                        message: error.message
                    });
                    console.log(error);
                });
            }

        },
        created() {
            this.getConfigInfo();
        },
    }
</script>

<style lang="scss" scoped>
    .content{
        .blocknote{
            height: 60px;
            line-height: 60px;
            margin: 20px;
            background-color: lightgrey;
            padding-left: 20px;
            span{
                font-size: 18px;
            }
        }
        .page-table{
            padding: 10px 20px;
        }
        .page-table table {
            border-collapse: collapse;
        }
        .page-table th,.page-table td {
            text-align: center;
            font-size: 16px;
            word-break: break-all;
            font-weight: 400;
            padding: 8px;
            border: 1px #dbdbdb solid;
        }
        .page-table thead th {
            color: #333;
            height: 40px;
            border-color: #fff;
            background: #ccc;
            font-weight: normal;
        }
        .page-table tbody td {
            height: 30px;
        }
        .active{
            color:red;
        }
        .normalClass{
            color:#333;
        }
    }
.last-page{
    td:first-child{
        width: 30%;
    }
}
</style>